module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "545px",
      "setClass": "no-padding-ever",
      "closeText": "Nej tack, gå till varukorgen",
      "showClose": false
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('div', {
    staticClass: "delivery-wrapper"
  }, [(_vm.possibleWithDelivery) ? _c('h2', [_vm._v("Spara tid – förboka utrustning med gratis utkörning\n      "), (_vm.accomodationsToSelect.length > 1) ? _c('span', [_vm._v("till " + _vm._s(_vm.accomodationsToSelect[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('h2', [_vm._v("Spara tid – förboka utrustning\n    ")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery) ? _c('ul', [_c('li', [_vm._v("Allt är klart när du kommer hit.")]), _vm._v(" "), _c('li', [_vm._v("Gratis utkörning och hämtning.")]), _vm._v(" "), _c('li', [_vm._v("Mer tid till skidåkning!")])]) : _vm._e(), _vm._v(" "), (_vm.possibleWithStorage) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  }), _vm._v(" Obs! Nattförvaring")], 1), _vm._v(" "), _c('p', [_vm._v("Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('p', [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.accomodation)) ? _c('div', {
    staticClass: "blocked"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('general.people-count')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v("Boka gratis utkörning av utrustning")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery) ? _c('button', {
    staticClass: "white border",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBookingNormal()
      }
    }
  }, [_vm._v("Boka utrustning att hämta själv")]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBookingNormal()
      }
    }
  }, [_vm._v("Boka utrustning")]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "close-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doClose()
      }
    }
  }, [_vm._v("Nej tack, jag bokar senare")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd09ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CartHighFiveAccomodationModal.vue
// module id = 936
// module chunks = 0